import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Filesharing = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16 19h3a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6.465a1 1 0 0 1-.832-.445l-1.11-1.664A2 2 0 0 0 8.93 4H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h3m4 0v-6m0 0 2.5 2.5M12 13l-2.5 2.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M2 5.75A2.75 2.75 0 0 1 4.75 3h4.18c.92 0 1.778.46 2.288 1.225l1.11 1.664a.25.25 0 0 0 .207.111h6.715A2.75 2.75 0 0 1 22 8.75v8.5A2.75 2.75 0 0 1 19.25 20h-6.5v-5.19l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22V20h-6.5A2.75 2.75 0 0 1 2 17.25z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
